export default {
  /**
   * 审核通过
   */
  AUDIT_RESULT_PASS: '1',

  /**
   * 审核不通过
   */
  AUDIT_RESULT_FAIL: '2',
  /**
   * 审核中
   */
  AUDIT_ING: '0',

  /**
   * 部分同意
   */
  AUDIT_PARTIALLY_AGREE: '3'
};
